<template>
  <div class="flex flex-col justify-center">
    <label v-if="name"
      class="text-sm text-blackish pl-2" :class="fontHairline()">
      {{ name }}
    </label>
    <label
      class="block border-b border-gray-300 pt-1 pb-2 pl-2"
    >
      {{ value }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: {},
    value: {},
    type: {
      default: 'text',
    },
  },

  computed: {
    nameToKebab() {
      return this.toKebab(this.name);
    },
  },

  methods: {
    toKebab(value) {
      return value.split(' ').join('-').toLowerCase();
    },

  },
};
</script>

<style lang="scss" scoped>
label {
  pointer-events:none;
  left: .5rem;
  top: 10px;
  transition:0.2s ease all;
}

input {
    transition:0.2s ease all;
}

input:focus ~ label, input:valid ~ label {
  @apply text-blackish font-normal;
  top: -15px;
}
</style>
